import { differenceInWeeks as differenceInWeeksFns } from 'date-fns';

export default function differenceInWeeks(
  dateLeft: Date,
  dateRight: Date,
): number {
  return differenceInWeeksFns(dateLeft, dateRight);
}
